import { userGetUsersRequest } from '@/modules/user/userActions';
import type { User } from '@/modules/user/userTypes';
import type { RootState } from '@/rootReducer';
import { useCallback, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useUserData } from './useUserData';

export const useUsersData = () => {
	const [users] = useSelector<RootState, [Array<User>]>(
		state => [state.user.getIn(['users', 'data']).toJS()],
		shallowEqual
	);

	const dispatch = useDispatch();

	const getUsers = useCallback(
		() => dispatch(userGetUsersRequest()),
		[dispatch]
	);

	const { user } = useUserData();

	useEffect(() => {
		if (
			user?.role === 'Admin' ||
			user?.role === 'Manager' ||
			user?.role === 'VA'
		) {
			getUsers();
		}
	}, [getUsers, user?.role]);

	return { users };
};
